import { render, staticRenderFns } from "./TabelaAvaliacoes.vue?vue&type=template&id=e7d63ee0&"
import script from "./TabelaAvaliacoes.vue?vue&type=script&lang=js&"
export * from "./TabelaAvaliacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports